export default function normalise(value, MAX, MIN = 0) {
    return (value - MIN) * 100 / (MAX - MIN)
}